import type { FC, ReactElement } from 'react'
import type { ShowProps } from '@app/components/util/Show/types'

export const isShowComponent = (entity: unknown): entity is ReactElement<ShowProps> =>
  ((entity as ReactElement<ShowProps>)?.type as FC<ShowProps>)?.displayName === 'Show'
